import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width={10} height={10} fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <g clipPath="url(#clip0_3256_103809)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.24802 8.55136L8.86852 4.17674C9.63652 3.4496 9.5771 2.1624 8.73752 1.33699C7.9176 0.531023 6.66724 0.47564 5.94456 1.21328L1.45007 5.80082C1.45007 5.80082 2.4457 6.19693 3.14539 6.88476C3.84508 7.57257 4.24802 8.55136 4.24802 8.55136Z"
        fill="white"
        stroke="#070F21"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.08861 9.3674L4.2454 8.55483C4.2454 8.55483 3.84336 7.57569 3.14431 6.88724C2.44525 6.19877 1.44999 5.80176 1.44999 5.80176L0.620031 8.89469C0.547727 9.16411 0.818193 9.43697 1.08861 9.3674Z"
        fill="white"
        stroke="#070F21"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3256_103809">
        <rect width="10" height="10" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const MinEditIcon = memo(ForwardRef);
export default MinEditIcon;
